import React from 'react';
import PropTypes from 'prop-types';
import { Item, Grid, Header } from 'semantic-ui-react';
import EscaypeDial from './EscaypeDial';
import '../styles/Forecast.css';

const Forecast = function(props) {
  return (
    <Grid>
      <Grid.Row columns={1} textAlign='center'>
        <Grid.Column>
          <Header as='h1'>{props.response.potential === -1 ? 'No moonburn is possible.' : `${props.response.city}, ${props.response.state}`}</Header>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={2} textAlign='center' style={{paddingBottom: '0.5em'}}>
        <Grid.Column>
          <span style={{fontSize: 'small'}}>{props.response.potential === -1 ? 'station: n/a' : `station: ${props.response.obsLat}, ${props.response.obsLon}`}</span>
        </Grid.Column>
        <Grid.Column>
          <span style={{fontSize: 'small'}}>{`${props.response.todaysDate} | ${props.response.event}`}</span>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={2} textAlign='center' style={{paddingTop: '0px'}}>
        <Grid.Column>
          <EscaypeDial dialType='potential' value={props.response.potential}/>
        </Grid.Column>
        <Grid.Column>
          <EscaypeDial dialType='skunk' value={props.response.skunk}/>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <Item.Group className='unstackable forecast-items'>
            <Item>
              <Item.Image size='mini' src='/images/g6984.png' className='cloud-height' />
  <Item.Content verticalAlign='middle'>{props.response.potential === -1 ? 'n/a' : props.response.cloudHeight}{(props.response.description && props.response.description.includes('Low clouds and fog are possible')) ? ' (FOG POSSIBLE)' : '' }</Item.Content>
            </Item>

            <Item>
              <Item.Image size='mini' src='/images/path6856.png' />
              <Item.Content verticalAlign='middle'>{props.response.potential === -1 ? 'n/a' : props.response.cloudCover}</Item.Content>
            </Item>

            <Item>
              <Item.Image size='mini' src='/images/g7104.png' />
              <Item.Content verticalAlign='middle'>{props.response.potential === -1 ? 'n/a' : props.response.bestTimeStr}</Item.Content>
            </Item>

            <Item>
              <Item.Image size='mini' src='/images/g8121.png' />
              <Item.Content verticalAlign='middle'>{`${props.response.sunAzimuth.toFixed(2)}\u00b0 | ${props.response.eventTime}`}</Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <p style={{whiteSpace: 'pre-wrap'}}>{props.response.potential === -1 ? 'We have determined that the conditions for a moonburn (i.e moon rises/sets when the sky is dark enough) are not met.'
          : props.response.description}</p>
          <p>{`Last updated: ${props.response.timeUploaded}`}</p>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column>
          <p style={{whiteSpace: 'pre-wrap'}}>Forecaster's Note:<br />{`${props.response.forecastersNote} (${props.response.forecastersNoteTime})`}</p>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

Forecast.propTypes = {
  response: PropTypes.shape({
    bestTimeStr: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    cloudCover: PropTypes.string.isRequired,
    cloudHeight: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    event: PropTypes.string.isRequired,
    eventTime: PropTypes.string.isRequired,
    forecastersNote: PropTypes.string.isRequired,
    forecastersNoteTime: PropTypes.string.isRequired,
    obsLat: PropTypes.number.isRequired,
    obsLon: PropTypes.number.isRequired,
    potential: PropTypes.number.isRequired,
    skunk: PropTypes.number.isRequired,
    state: PropTypes.string.isRequired,
    sunAzimuth: PropTypes.number.isRequired,
    timeUploaded: PropTypes.string.isRequired,
    todaysDate: PropTypes.string.isRequired
  }).isRequired
};


export default Forecast;
